import {defineRemotePublicPath, withCustomProtocol} from './definer'

const dynamicPublicPath = withCustomProtocol(
  defineRemotePublicPath(window.serverData.runtimeEnv.platform, window.serverData.runtimeEnv.proxySettings),
  window.serverData.runtimeEnv.buildAssetsProtocol,
)

if (dynamicPublicPath) {
  __webpack_public_path__ = dynamicPublicPath
}
